import {request} from "@/service/request"
let url = process.env.VUE_APP_BASE_URL // 接口地址
// let url = 'http://192.168.2.25:9999' //java正式接口
// 动态url
export const getNoticeQueryHistoryList = (params) => {
    return request({
        url: url + '/notice/queryHistoryList',
        method: 'get',
        params
    })
}

export const postNoticeSubscription = (data) => {
    return request({
        url: url + '/notice/subscription',
        method: 'post',
        data
    })
}
export const getBusinessCardPersonGetPersonBusinessCard = (params) => {
    return request({
        url: url + '/crm/businessCardPerson/getPersonBusinessCard',
        method: 'get',
        params
    })
}
export const getPerformanceRecognitionGetWxInfo = (data) => {
    return request({
        url: 'https://file-preview.wmenzai.com/signature.php',
        method: 'post',
        data
    })
}
export const getPerformanceRecognitionGetWxInfo2 = (data) => {
    return request({
        url: url + '/crm/performanceRecognition/getWxInfo',
        method: 'post',
        data
    })
}

export const getJsapiTicket = (params) => {
    return request({
        url: url + '/crm/performanceRecognition/getJsapiTicket',
        method: 'get',
        params
    })
}

// 素材库无token
export const postMaterialList = (data) => {
    return request({
        url: url + '/crm/material/weComMaterialList',
        method: 'post',
        data
    })
}
// 素材合集下拉
export const postQueryMaterialCompilation = (data) => {
    return request({
        url: url + '/crm/material/queryMaterialTitleWeCom',
        method: 'post',
        data
    })
}
// 素材合集下拉
export const postMaterialApplicationJsapi = (params) => {
    return request({
        url: url + '/crm/material/applicationJsapi',
        method: 'get',
        params
    })
}
